import * as React from "react";
import { useState, FC, Dispatch, SetStateAction } from "react";

import { MultipleTreeNode } from "../TreePicklistNode/MultipleTreeNode";
import { SummaryState } from "../TreePicklistItemProvider";
import { patchTreeStructure } from "../patchTreeStructure";
import { IResetNodeManager } from "../TreePicklistNode/utils/useResetCallbacks";
import { TreePicklistItem } from "../TreePicklistItem";
import { isNotNullOrEmpty } from "../../../../../../../Common/TypingUtils";

import { PicklistModalProps } from "./TreePicklistModal";

interface MultipleTreeProps {
    items: TreePicklistItem[];
    searchQuery: string;
    modalProps: PicklistModalProps;
    needNodesToOpen: TreePicklistItem[];
    resetNodeStateManager: IResetNodeManager;
    nodesToSave: TreePicklistItem[];
    setNodesToSave: Dispatch<SetStateAction<TreePicklistItem[]>>;
    onLoadingError: () => void;
}

export const MultipleTree: FC<MultipleTreeProps> = ({
    items,
    searchQuery,
    modalProps,
    needNodesToOpen,
    resetNodeStateManager,
    nodesToSave,
    setNodesToSave,
    onLoadingError,
}) => {
    const [rootState, setRootState] = useState<SummaryState>(SummaryState.Indeterminate);

    const searchMode = isNotNullOrEmpty(searchQuery);

    const updateNodesToSave = (item: TreePicklistItem, newState: SummaryState) => {
        setRootState(SummaryState.Indeterminate);
        patchTreeStructure(item, newState, setNodesToSave);
    };

    return (
        <>
            {items.map(item => (
                <MultipleTreeNode
                    {...modalProps}
                    key={item.elementId}
                    item={item}
                    parentState={rootState}
                    nodesToSave={nodesToSave}
                    resetNodeStateManager={resetNodeStateManager}
                    nestingLevel={1}
                    searchMode={searchMode}
                    needNodesToOpen={needNodesToOpen}
                    updateNodesToSave={updateNodesToSave}
                    onLoadingError={onLoadingError}
                    recalculateParentState={() => {
                        /* no parent */
                    }}
                />
            ))}
        </>
    );
};
